module.exports = __webpack_public_path__ + "static/assets/24af65b461f1a63b869ca426165e5798.png";